<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <pr-input-select-template
      formControlName="scpiOwnershipType"
      [options]="options"
      [isGrid]="true"
    >
      <ng-template #optionTemplate let-option let-id="index">
        @if (id == 0) {
          <div class="col-md-12">
            <title
              direction="left"
              [style]="{
                'font-size': '16px',
                color: '#3376F6',
              }"
            >
              En pleine propriété
            </title>
          </div>
        }
        @if (id == 2) {
          <div class="col-md-12">
            <title
              direction="left"
              [style]="{
                'font-size': '16px',
                color: '#3376F6',
                'margin-top': '1.5rem',
              }"
            >
              En démembrement
            </title>
            <!-- <span> en démembrement </span> -->
          </div>
        }
        <div class="col-md-6 mt">
          <residence-box
            [suffix]="option.suffix"
            [title]="option.label"
            [svg]="option.svg"
          ></residence-box>
        </div>
      </ng-template>
    </pr-input-select-template>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
